import createIcon from '../../createIcon';

/**
 * @component @name LocalTaxi
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguOTIgNi4wMUMxOC43MiA1LjQyIDE4LjE2IDUgMTcuNSA1SDE1VjNIOVY1SDYuNUM1Ljg0IDUgNS4yOSA1LjQyIDUuMDggNi4wMUwzIDEyVjIwQzMgMjAuNTUgMy40NSAyMSA0IDIxSDVDNS41NSAyMSA2IDIwLjU1IDYgMjBWMTlIMThWMjBDMTggMjAuNTUgMTguNDUgMjEgMTkgMjFIMjBDMjAuNTUgMjEgMjEgMjAuNTUgMjEgMjBWMTJMMTguOTIgNi4wMVpNNi41IDE2QzUuNjcgMTYgNSAxNS4zMyA1IDE0LjVDNSAxMy42NyA1LjY3IDEzIDYuNSAxM0M3LjMzIDEzIDggMTMuNjcgOCAxNC41QzggMTUuMzMgNy4zMyAxNiA2LjUgMTZaTTE3LjUgMTZDMTYuNjcgMTYgMTYgMTUuMzMgMTYgMTQuNUMxNiAxMy42NyAxNi42NyAxMyAxNy41IDEzQzE4LjMzIDEzIDE5IDEzLjY3IDE5IDE0LjVDMTkgMTUuMzMgMTguMzMgMTYgMTcuNSAxNlpNNSAxMUw2LjUgNi41SDE3LjVMMTkgMTFINVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalTaxi = createIcon('LocalTaxi', [
  [
    'path',
    {
      d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9V5H6.5C5.84 5 5.29 5.42 5.08 6.01L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21H20C20.55 21 21 20.55 21 20V12L18.92 6.01ZM6.5 16C5.67 16 5 15.33 5 14.5C5 13.67 5.67 13 6.5 13C7.33 13 8 13.67 8 14.5C8 15.33 7.33 16 6.5 16ZM17.5 16C16.67 16 16 15.33 16 14.5C16 13.67 16.67 13 17.5 13C18.33 13 19 13.67 19 14.5C19 15.33 18.33 16 17.5 16ZM5 11L6.5 6.5H17.5L19 11H5Z',
      key: '523zx8',
    },
  ],
]);

export default LocalTaxi;
